import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'

export const generatePDF = async (): Promise<jsPDF> => {
  const pdf = new jsPDF()

  const htmlPdfElements = [
    ...document.querySelectorAll('.periodontal-pdf__page'),
  ] as HTMLElement[]

  const pageHeight = htmlPdfElements[0].clientHeight - 70
  const pageWidth = htmlPdfElements[0].clientWidth

  for (const htmlElement of htmlPdfElements) {
    const canvas = await html2canvas(htmlElement, {
      allowTaint: true,
      useCORS: true,
      scale: 1.7,
    })

    const imageData = canvas.toDataURL('image/png', 1.0)

    pdf.addImage(imageData, 10, 0, pageWidth / 4, pageHeight / 4)

    if (isNeedAddPage(htmlPdfElements, htmlElement)) {
      pdf.addPage()
    }
  }

  return pdf
}

export const getPeriodontalPDF = async (): Promise<File> => {
  const pdf = await generatePDF()
  const pdfBlob = pdf.output('blob')

  return new File([pdfBlob], 'periodontal_report')
}

const isNeedAddPage = (
  pages: HTMLElement[],
  addedPage: HTMLElement
): boolean => {
  const index = pages.findIndex((page) => page === addedPage)

  return index !== pages.length - 1
}
